import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-subscription-steps',
  templateUrl: './landing-subscription-steps.component.html',
  styleUrls: ['./landing-subscription-steps.component.scss']
})
export class LandingSubscriptionStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
